<template>
  <b-container
    fluid
    class="d-flex flex-row align-items-center justify-content-center full-height position-relative"
  >
    <b-row class="justify-content-center w-100">
      <b-col
        md="auto"
        class="d-flex flex-column align-items-center text-center px-5 gap-8"
      >
        <!-- Logo -->
        <div>
          <img
            src="@/assets/img/voomp-brand.png"
            width="140"
            height="28.77"
            alt="Voomp Creators"
            class="logo-img"
          />
        </div>

        <!-- Textos -->
        <div class="text-container text-left">
          <p class="text-primary text-lg font-bold fs-5 pb-2 mb-0">
            {{ maintenanceMode }}
          </p>
          <p class="text-primary text-base pb-2 mb-0">
            Volte em breve e aproveite uma experiência ainda melhor.
          </p>
          <p class="text-primary text-base pb-2 mb-0">
            Obrigado pela compreensão!
          </p>
        </div>
      </b-col>
    </b-row>

    <!-- Border Top Personalizado -->
    <div class="border-top-custom"></div>
  </b-container>
</template>

<script>
export default {
  name: "MaintenanceMode",
  data() {
    return {
        maintenanceMode: process.env.VUE_APP_MAINTENANCE_MESSAGE || "Estamos fazendo uma pausa para melhorias, das 00h - 03h.",
    }
  }
};
</script>

<style scoped>
.gap-8 {
  gap: 2rem;
}

.font-bold {
  font-weight: 600 !important;
}

.text-lg {
  font-size: 1rem;
  line-height: 1.75rem;
}

.text-base {
  font-size: 0.9rem;
  line-height: 1.5rem;
  font-weight: 400 !important;
}

.full-height {
  min-height: 100vh;
}

.border-top-custom {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 8px;
  background-color: #f58220;
}

.logo-img {
  max-height: 8rem;
  max-width: 140px;
  object-fit: contain;
}

.text-primary {
  color: #0f2642 !important;
}
</style>
